<script setup lang="ts">
import { userStore } from "@/stores/user";
import { createItem } from "./tools/createItem";
import { createPet } from "./tools/createPet";
import { ref } from "vue";

const name = ref("");
const speciesName = ref("")
const selectedItemType = ref("");
var itemTypes: Array<string> = ["food", "entertainment"];
const user = userStore();

const props = defineProps<{
  thing: string | null;
}>();

async function handleSubmit() {
  var sanitizedName = name.value.toLowerCase().replace(/\s/g, "_").replace(/\W+/g, "")
  name.value = sanitizedName
  const path = `images/${user.getUser?.PK!}/${props.thing}/${name.value}.png`;

  switch (props.thing) {
    case "item":
      if (user.getUser.itemsRemaining - 1 < 0) {
        // Make sure creation won't put the user into negative numbers.
        return;
      } else {
        if (name.value && selectedItemType.value) {
          createItem(name.value, path, selectedItemType.value, user.getUser);
        } else {
          alert("Please use half-width alphanumeric characters (A-Z, 0-9).")
          return
        }
      }
      break;
    case "pet":
      if (user.getUser.petsRemaining - 1 < 0) {
        // Make sure creation won't put the user into negative numbers.
        return;
      } else {
        if (name.value && speciesName.value) {
          createPet(name.value, path, speciesName.value, user.getUser);
        } else {
          alert("Please use half-width alphanumeric characters (A-Z, 0-9).")
          return
        }
      }
      break;

    default:
      break;
  }
}
</script>
<template>
  <v-card class="mx-auto" v-if="props.thing == 'item'">
    <v-col class="text-center">
      <v-card-title>Please name your {{ props.thing }}</v-card-title>
      <v-form @submit.prevent="handleSubmit()">
        <v-text-field v-model="name" label="Item name"></v-text-field>

        <v-select
          v-model="selectedItemType"
          label="Item Type"
          :items="itemTypes"
          item-title="[0]"
          single-line
        ></v-select>
        <v-btn class="my-2" text="Create!" type="submit"></v-btn>
      </v-form>
    </v-col>
  </v-card>

  <v-card class="mx-auto" v-if="props.thing == 'pet'">
    <v-col class="text-center">
      <v-card-title>Please name your {{ props.thing }}</v-card-title>
      <v-form @submit.prevent="handleSubmit()">
        <v-text-field v-model="name" label="Pet name"></v-text-field>
        <v-text-field v-model="speciesName" label="Pet Species"></v-text-field>
        <v-btn class="my-2" text="Create!" type="submit"></v-btn>
      </v-form>
    </v-col>
  </v-card>
</template>
